import Vue from 'vue'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import VueLazyload from 'vue-lazyload'
import App from '@/App.vue'
import router from '@/router.js'

import VueApollo from 'vue-apollo'

import '@/assets/css/tailwind.css'
import '@/assets/css/style.min.css'
import store from '@/store/store'
import axios from '@/axios'
// import into project
import VuejsDialog from 'vuejs-dialog'
//import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
import { languages } from './i18n/index.js'
//import { defaultLocale } from './i18n/index.js'

import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import Title from '@/components/Title.vue'
import Subtitle from '@/components/Subtitle.vue'
import Card from '@/components/Card.vue'
import Container from '@/components/Container.vue'
import Loader from '@/components/Loader.vue'
import ButtonBlack from '@/components/ButtonBlack.vue'

// Components

Vue.component('Container', Container)
Vue.component('Title', Title)
Vue.component('Subtitle', Subtitle)
Vue.component('Card', Card)
Vue.component('Loader', Loader)
Vue.component('ButtonBlack', ButtonBlack)

Vue.use(VueApollo)
Vue.use(VueLazyload)
Vue.use(require('vue-moment'))
Vue.use(Vuelidate)
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(VuejsDialog)

Vue.prototype.$axios = axios

// Configurations:
Vue.config.productionTip = false

// i18n

const messages = Object.assign(languages)
var i18n = new VueI18n({
	//	locale: defaultLocale,
	locale: 'es',
	//	fallbackLocale: 'es',
	messages
})

import apolloClient from './apollo/client'

const apolloProvider = new VueApollo({
	defaultClient: apolloClient
})

new Vue({
	router,
	store,
	i18n,
	apolloProvider,
	render: h => h(App)
}).$mount('#app')
